@if(loading()) {
  <div class="checking-container">
    <div *ngIf="loading()" class="spinner-container">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="15">
      </mat-progress-spinner>
    </div>
    <div>Checking onboard...</div>
  </div>
} @else {
  @if(hasLink()) {
    <div class="success">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <div>
        This show is successfully connected with Paypal ({{linkData().email}} - {{linkData().merchantId}})
      </div>
    </div>

    @if (onboardErrors().length) {
      <div class="error-container">
        <div>
          Please correct the following errors:
        </div>
        <ul>
        @for(error of onboardErrors(); track error.type) {
          <li>{{error.message}}</li>
        }
        </ul>
        <button mat-raised-button (click)="checkErrorsAgain()">
          <mat-icon>refresh</mat-icon>
          <span>Check errors again after you solved the errors</span>
        </button>
      </div>
    }
  } @else {
    @if(fromOnboard) {
      <p>If you have just done an onboarding process with Paypal. Sometimes it takes some minutes to be active.</p>
      <p>Please check again by clicking this button. Please do not onboard again</p>
      <button mat-raised-button (click)="checkAgain()">
        <mat-icon>refresh</mat-icon>
        <span>Check onboard again</span>
      </button>
    }

    @if(onBoardUrl) {
      <div class="buttons-row">
        <div dir="ltr" style="text-align: left;" trbidi="on">
         <div #scriptDiv></div>
          <a class="pp-btn" data-paypal-button="true" href="{{onBoardUrl}}&displayMode=minibrowser" target="PPFrame" (click)="markAsClicked()">
            <div class="btn-content">
              <svg width="18" height="18" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" class="ppLogo">
                <path d="M31.0619 10.9442C31.1607 5.81765 26.9309 1.8832 21.1148 1.8832H9.08474C8.80449 1.88325 8.53346 1.9833 8.3204 2.16538C8.10735 2.34745 7.96627 2.59959 7.92255 
                2.87641L3.10245 32.9954C3.08088 33.1318 3.08915 33.2713 3.12669 33.4043C3.16422 33.5373 3.23014 33.6605 3.31988 33.7656C3.40963 33.8706 3.52107 33.955 3.64655 34.0128C3.77202 34.0706 3.90854 34.1006 4.0467 34.1006H11.1737L10.0599 41.0761C10.0385 41.2125 10.0468 41.352 10.0844 41.4849C10.1219 41.6178 10.1879 41.741 10.2776 41.846C10.3673 41.951 10.4787 42.0353 10.6042 42.0931C10.7296 42.1509 10.8661 42.1808 11.0042 42.1809H16.81C17.0902 42.1808 17.3399 42.0808 17.553 41.8987C17.7661 41.7166 17.8006 41.4645 17.8443 41.1877L19.5483 31.1604C19.592 30.8835 19.733 30.5247 19.9461 30.3426C20.1591 30.1604 20.345 30.0603 20.6253 30.0602H24.1784C29.874 30.0602 34.7068 26.0117 35.5904 20.3811C36.2155 16.3838 34.5019 12.7475 31.0619 10.9442Z" fill="#FFFFFF">
                </path>
  
                <path d="M12.7155 22.9938L10.9404 34.2495L9.82674 41.3102C9.80525 41.4466 9.81357 41.5861 9.85115 41.719C9.88872 41.8519 9.95464 41.9751 10.0444 42.0801C10.1341 42.1851 10.2455 
                42.2694 10.371 42.3272C10.4964 42.385 10.6329 42.4149 10.771 42.415H16.9152C17.1955 42.4149 17.4665 42.3148 17.6796 42.1328C17.8926 41.9507 18.0337 41.6986 18.0774 41.4218L19.6962 31.1602C19.7398 30.8833 19.8808 30.631 20.0939 30.4489C20.307 30.2667 20.5781 30.1666 20.8584 30.1665H24.4753C30.171 30.1665 35.0038 26.0115 35.8873 20.3809C36.5139 16.384 34.5019 12.7475 31.0619 10.9442C31.0535 11.3699 31.0164 11.7948 30.9505 12.2154C30.0674 17.8456 25.2337 22.001 19.5385 22.001H13.8777C13.5974 22.0011 13.3264 22.1012 13.1134 22.2832C12.9003 22.4653 12.7592 22.717 12.7155 22.9938Z" fill="#B4D0E7">
                </path>
  
                <path d="M10.9404 34.2495L3.79121 34.2494C3.65307 34.2495 3.51656 34.2196 3.39109 34.1618C3.26561 34.104 3.15416 34.0197 3.0644 33.9147C2.97465 33.8097 2.90873 33.6865 2.87119 
                33.5536C2.83366 33.4206 2.82539 33.2811 2.84696 33.1447L7.66707 2.57842C7.71079 2.30159 7.85186 2.04945 8.06492 1.86738C8.27797 1.68531 8.54901 1.58525 8.82926 1.58521H21.1149C26.931 1.58521 31.1607 5.81765 31.0619 10.9442C29.6144 10.1854 27.9144 9.75115 26.0513 9.75115H15.8085C15.5282 9.75121 15.2571 9.85134 15.0441 10.0335C14.831 10.2157 14.69 10.4679 14.6463 10.7448L12.7155 22.9938L10.9404 34.2495Z" fill="#FFFFFF">
                </path>
              </svg>
              <span class="btn-text">Connect with PayPal</span>
            </div>
          </a>
        </div>
        @if(showRetryButton) {
          <div>
            <button mat-raised-button (click)="checkAgain()">
              <mat-icon>refresh</mat-icon>
              <span>Check onboard</span>
            </button>
          </div>
        }
      </div>
    }
  }
  @if(error()) {
    <div class="inline">
      <div>{{error()}}</div>
      <button mat-raised-button (click)="tryAgain()">
        <mat-icon>refresh</mat-icon>
        <span>Try again</span>
      </button>
    </div>
  }
}
